import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

// Busca de cadastro por CPF ou e-mail (so administrador). POST para o CPF nao
// ir na URL.
export default class BuscaCadastroServices {
	buscar (termo) {
		return axios.post(`${REQUEST_URL}/busca-cadastro`, { termo }, {
			headers: {"Authorization": localStorage.getItem("token")}
		}).then((response) => response.data);
	}
}



// WEBPACK FOOTER //
// ./src/services/buscaCadastro.js